<template>
	<div id="app">
		<HeaderTop></HeaderTop>

		<HeaderTitle :pageName="pagename"></HeaderTitle>
		<div class="content">
			<section class="banner_div word">
				<div class="topmsg">
					<div class="m-l">
						<div>
							<h3 class="font1">{{$t('payment.ordernumber')}}：{{orderNo}}</h3>
							<h3 class="font2">
								{{$t('payment.Tips')}}
							</h3>
						</div>
					</div>
					<div class="m-r">
						{{$t('payment.Totalamount')}}：<span>{{`${$type == 1?'￥':'$'}` + (payAmount / 100).toFixed(2)}}</span>
					</div>
				</div>

				<div class="pay-box">

					<div class="zfb-box" :class="alipayCheck ? 'checked-shadow' : ''" @click="checkPayType(1)"  v-if="$type == 1 || $type == 3">
						<div class="z-l">
							<span class="checkbox" ><span v-if="alipayCheck" class="checked-style"></span></span>
							<div class="img"><img src="@/assets/images/zfb.png" alt=""></div>
							<div class="box-font">{{$t('payment.Alipay')}}</div>
							<div class="box-font-m">{{$t('payment.use')}}</div>
							<span class="b">{{$t('payment.recommend')}}</span>
						</div>
						<div class="z-r">
							{{$t('payment.payment')}}<span>￥{{(money / 100).toFixed(2)}}</span>
						</div>
					</div>

					<div class="zfb-box paypal-box" :class="paypalCheck ? 'checked-shadow' : ''" @click="checkPayType(2)"  v-if="$type == 2 || $type == 3">
						<div class="z-l">
							<span class="checkbox" ><span v-if="paypalCheck" class="checked-style"></span></span>
							<div class="img"><img src="@/assets/images/pp.png" alt=""></div>
							<div class="box-font">Paypal</div>
							<div class="box-font-m">{{$t('payment.txt')}}</div>
						</div>
						<div class="z-r">
							{{$t('payment.payment')}}<span>${{(realPayAmount / 100).toFixed(2)}}</span>
						</div>
					</div>

					<div class="zfb-box paypal-box" :class="balanceCheck ? 'checked-shadow' : ''" @click="checkPayType(3)">
						<div class="z-l">
							<span class="checkbox" ><span v-if="balanceCheck" class="checked-style"></span></span>
							<div class="img"><img src="@/assets/images/balance.png" alt=""></div>
							<div class="box-font">{{$type === 1 ? $t('payment.RMB') : $t('payment.dollar')}}({{`${$type == 1?'￥':'$'}` + (accountBalance / 100).toFixed(2)}})</div>
							<div class="box-font-m">{{$t('payment.balance')}}</div>
						</div>
						<div class="z-r">
							{{$t('payment.payment')}}<span>{{`${$type == 1?'￥':'$'}` + (money / 100).toFixed(2)}}</span>
						</div>
					</div>

					<!--<div v-if="$type === 2" class="zfb-box paypal-box" :class="dollarCheck ? 'checked-shadow' : ''"  @click="checkPayType(4)">
						<div class="z-l">
							<span class="checkbox"><span v-if="dollarCheck" class="checked-style"></span></span>
							<div class="img"><img src="@/assets/images/yue.png" alt=""></div>
							<div class="box-font">{{$t('payment.dollar')}}(${{balanceUs / 100}})</div>
							<div class="box-font-m">{{$t('payment.balance')}}</div>
						</div>
						<div class="z-r">
							{{$t('payment.payment')}}<span>${{(realPayAmount / 100).toFixed(2)}}</span>
						</div>
					</div>-->

					<div class="btn-box">
						<div class="btn" @click="linkToPay">{{$t('payment.Paynow')}}</div>
					</div>
					<!-- 设置支付密码 -->
					<el-dialog :title="$t('payment.setpassword')" :visible.sync="dialogVisible" width="30%" @close="close" :close-on-click-modal="false">
						<el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
							<el-form-item prop="email" :label="$t('payment.mailbox')" :rules="[
					        { required: true, message: $t('payment.inpmailbox'), trigger: 'blur' },
					        { type: 'email', message: $t('payment.zqmailbox'), trigger: ['blur', 'change'] }
					      ]">
								<div class="flex_start">
									<el-input v-model="dynamicValidateForm.email" disabled></el-input>
									<el-button type="primary" @click="send" v-if="sendMsg">{{$t('payment.obtain')}}</el-button>
									<el-button type="info" disabled v-else>{{timer}}{{$t('payment.send')}}</el-button>
								</div>
							</el-form-item>
							<el-form-item :label="$t('payment.code')" prop="code" :rules="[
					        { required: true, message: $t('payment.input'), trigger: 'blur' },
					      ]">
								<el-input v-model="dynamicValidateForm.code"></el-input>
							</el-form-item>
							<el-form-item :label="$t('payment.Paymentpassword')" prop="psd" :rules="[
							  { required: true, message: $t('payment.input'), trigger: 'blur' },
							]">
								<el-input v-model="dynamicValidateForm.psd" type="password"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="onSubmit('dynamicValidateForm')">{{$t('payment.setup')}}</el-button>
							</el-form-item>
						</el-form>

					</el-dialog>
					<!-- 输入支付密码 -->
					<el-dialog :title="$t('payment.inppassword')" :visible.sync="flag" width="30%" :close-on-click-modal="false">
						<el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic"
						 @submit.native.prevent>
							<el-form-item :label="$t('payment.Paymentpassword')" prop="psd" :rules="[
							  { required: true, message: $t('payment.input'), trigger: 'blur' },
							]">
								<el-input v-model="dynamicValidateForm.psd" type="password"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="determine('dynamicValidateForm')">{{$t('payment.determine')}}</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import HeaderTitle from "../assembly/HeaderTitle";
	import HeaderTop from '../assembly/HeaderTop';
	import ModelPop from '../assembly/ModelPop';

	export default {
		name: "payPage",
		components: {
			HeaderTitle,
			HeaderTop,
			ModelPop
		},
		data() {
			return {
				timer: 60,
				sendMsg: true, //是否显示发送验证码
				dynamicValidateForm: {
					code: '',
					email: '',
					psd: ''
				},
				dialogVisible: false,
				pagename: '购物车',
				topType: 'usermsg',
				num: '1',
				alipayCheck: true,
				paypalCheck: false,
				balanceCheck: false,
				dollarCheck: false,
				orderNo: '',
				payAmount: -1,
				realPayAmount: -1,
				orderType: -1,
				money: '',
				payType: 1,
				flag: false,
				accountBalance: "",
				balanceUs: ""
			}
		},
		created() {
			this.paypalCheck = this.$type == 2 ? true : false
			this.payType = this.$type == 2 ? 2 : 1
			let data = JSON.parse(sessionStorage.getItem('paydatainfo'));
			this.pagename = this.$t('vip.Cashier');
			this.orderNo = data.orderNo;
			this.payAmount = data.payAmount;
			this.realPayAmount = data.payAmount;
			this.orderType = data.orderType;
			this.money = data.zhMoney;
			this.money = this.realPayAmount;
			this.dynamicValidateForm.email = JSON.parse(sessionStorage.getItem('user')).email;
			if (!data.zhMoney) {
				this.getMoney()
			}
			this.getUser()
		},
		methods: {
			// 清空输入框
			close() {
				this.dynamicValidateForm.code = ''
				this.dynamicValidateForm.psd = ''
			},
			// 获取账户信息
			getUser() {
				let url = "/api/account/getAccountAll";
				let data = {
					token: sessionStorage.getItem('token')
				};
				this.$get(url, data).then(res => {
					if (res.code == 0) {
						this.accountBalance = res.data.accountBalance
						this.balanceUs = res.data.balanceUs
						if (res.data.payPassword == null || !res.data.payPassword) {
							this.dialogVisible = true
						}
					}
				});
			},
			// 输入支付密码
			determine(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.getpayment()
					} else {
						return false;
					}
				});
			},
			// 设置支付密码
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let url = '/api/account/setPayPassword'
						let data = {
							code: this.dynamicValidateForm.code,
							payPassword: this.dynamicValidateForm.psd,
							token: sessionStorage.getItem('token')
						}
						this.$put(url, data).then(res => {
							if (res.code == 0) {
								this.$message({
									message: this.$t('Tips.setupsuc'),
									type: 'success'
								});
								this.dialogVisible = false
							}
						})
					} else {
						return false;
					}
				});
			},
			//发送验证码
			send() {
				if (this.dynamicValidateForm.email == '') {
					this.$message({
						message: this.$t('Tips.mailbox'),
						type: 'error'
					});
				} else {
					let url = '/api/account/sendMail'
					let data = {
						token: sessionStorage.getItem('token')
					}
					this.$get(url, data).then(res => {
						if (res.code == 0) {
							this.$message({
								message: this.$t('Tips.code'),
								type: 'success'
							});
							this.sendMsg = false
							let timerFn = setInterval(() => {
								if (this.timer != 0) {
									this.timer--
								} else {
									this.timer = 60;
									this.sendMsg = true
									clearInterval(timerFn)
								}
							}, 1000)
						} else {
							return
						}

					})
				}
			},
			getMoney() {
				/*let url = '/open/product/get/usd/price'
				this.$get(url, {
					unitPrice: this.payAmount
				}).then(res => {
					if (res.code == 0) {
						this.money = res.data
					}
				})*/
			},
			parentFn(payload) {
				console.log('登录' + payload)
			},
			getpayment() {
				//调起支付
				let url = this.orderType === 0 ? 'api/standard/order/pay/init' : 'api/customized/order/amount/pay';
				this.$post(url, {
					token: sessionStorage.getItem('token'),
					orderNo: this.orderNo,
					payType: this.payType,
					discountType: 3,
					discountAmount: 0,
					totalAmount: this.payAmount,
					integralNum: 0,
					payPassword: this.dynamicValidateForm.psd
				}).then(res => {
					if (res.code == 0) {
						if (this.payType == 3 || this.payType == 4) {
							this.$message({
								message:  this.$t('Tips.paymentsuc'),
								type: 'success'
							});
							setTimeout(() => {
								window.close();
							}, 2000)
						} else {
							document.write(res.data);
						}
					}
				});
			},
			//立即去支付
			linkToPay() {
				if (this.payType == 3 || this.payType == 4) {
					this.flag = true
					return false
				}
				this.getpayment()
			},
			//支付方式选择
			checkPayType(type) {
				this.payType = type
				if (type == 3 && this.money > this.accountBalance) {
					this.$message({
						message: this.$t('Tips.RMBaccount'),
						type: 'warning'
					});
					return false
				}
				if (type == 4 && this.realPayAmount > this.balanceUs) {
					this.$message({
						message:this.$t('Tips.USDaccount'),
						type: 'warning'
					});
					return false
				}
				switch (+type) {
					case 1:
						{
							this.alipayCheck = true;
							this.paypalCheck = false;
							this.balanceCheck = false;
							this.dollarCheck = false;
						}
						break;
					case 2:
						{
							this.alipayCheck = false;
							this.paypalCheck = true;
							this.balanceCheck = false;
							this.dollarCheck = false;
						}
						break;
					case 3:
						{
							this.alipayCheck = false;
							this.paypalCheck = false;
							this.balanceCheck = true;
							this.dollarCheck = false;
						}
						break;
					case 4:
						{
							this.alipayCheck = false;
							this.paypalCheck = false;
							this.balanceCheck = false;
							this.dollarCheck = true;
						}
						break;
				}
			}
		}
	};
</script>

<style scoped>
	/*<!---->*/
	.banner_div {
		padding-top: 32px;
	}

	.topmsg {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.erwm {
		width: 85px;
		height: 85px;
		background: #000;
		margin-right: 26px;
	}

	.font1 {
		font-size: 14px;
		color: #000;
		margin-bottom: 12px;
	}

	.font2 {
		color: #4a4a4a;
		font-size: 14px;
	}

	h3 {
		text-align: left;
	}

	h3 span {
		color: #ea2323;
		font-size: 14px;
	}

	.m-l {
		display: flex;
		align-items: center;
	}

	.m-r {
		align-items: center;
		display: flex;
		font-size: 14px;
		color: #000;
	}

	.m-r span {
		color: #EA2323;
		font-size: 24px;
		font-weight: bold;
	}

	.pay-box {
		width: 100%;
		/*padding: 61px 33px;*/
		background: #fff;
		box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
		margin-top: 27px;
		box-sizing: border-box;
	}

	.checked-shadow {
		box-shadow: 0 4px 24px 0 rgba(206, 206, 206, 0.43);
	}

	.zfb-box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding: 20px;
		box-sizing: border-box;
	}

	.z-l {
		display: flex;
		align-items: center;
	}

	.checkbox {
		display: inline-block;
		width: 20px;
		height: 20px;
		border: 1px solid #E2E2E2;
		border-radius: 3px;
		margin-right: 24px;
	}

	.checkbox>.checked-style {
		width: 8px;
		height: 15px;
		display: inline-block;
		border-right: 2px solid #1296DB;
		border-bottom: 2px solid #1296DB;
		transform: rotate(45deg);
	}

	.b {
		margin-left: 6px;
		width: 34px;
		height: 20px;
		color: #fff;
		text-align: center;
		font-size: 12px;
		background-image: linear-gradient(#1296DB, #427DD6);
		line-height: 20px;
		border-radius: 2px;
	}

	.img {
		width: 40px;
		height: 40px;
	}

	.img img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.box-font {
		font-size: 18px;
		color: #1A1A1A;
		margin-right: 67px;
		width: 100px;
		text-align: left;
	}

	.box-font-m {
		color: #666666;
		font-size: 14px;
	}

	.z-r {
		font-size: 14px;
		color: #000000;
		display: flex;
		align-items: center;
	}

	.z-r span {
		color: #EA2323;
		font-size: 24px;
		font-weight: bold;
		margin: 0 10px;
	}

	.paypal-box {
		margin-top: 40px;
	}

	/*.zfb-box.paypal-box {
    box-shadow: 0 0 0 0 #fff;
    border-bottom: 1px solid #E2E2E2;
  }*/

	.btn-box {
		padding-left: 70px;
	}

	.btn {
		width: 220px;
		height: 50px;
		background-image: linear-gradient(#3F9FEA, #0573CB);
		margin-top: 54px;
		text-align: center;
		line-height: 50px;
		color: #fff;
		font-size: 18px;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/pay/PayPage.vue